// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b1cb6f7","455":"6b82fd1b"}[chunkId] + ".chunk.js";
};